import "swiper/css";

import "./gallery";
import "./partners";
import "./offer";

if (document.querySelector("#viewMore")) {
  import("./viewMore");
}
if (document.querySelector("#doctors")) {
  import("./doctors");
}
if (document.querySelector(".effect-slider")) {
  import("./effectAfter");
}

if (document.querySelector(".reviews-slider")) {
  import("./reviews");
}

if (document.querySelector(".consultations-slider")) {
  import("./consultations");
}
